import React from "react";
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import './audienceBuilder.css';
import { Button, Input } from "@material-ui/core";
import { SelectionMenu } from "./components/selectionMenu/selectionMenu";
import { CaseBlock } from "./components/dragAndDrop/caseBlock";
import { filterSelectionList } from "./util/filterSelectionList";
import { addSelectionToList } from "./util/addSelectionToList";
import { checkOuroboros } from "./util/checkOuroboros";
import { mainTheme } from "../../theme/ddTheme";
import screenSizeLogo from './assets/screen-size.svg'
import { fetchSelections } from "./util/dataFetches/fetchSelection";
import { FilterSelector } from "./components/dragAndDrop/filterSelector";
import { updateFilterDataById } from "./util/updateFilterDataById";
import { siftFilterGrouping } from "./util/siftFilterGrouping";
import { buildLogicString } from "./util/createLogicString";
import AbortController from "abort-controller";
import { fetchCounts } from "./util/dataFetches/fetchCounts";
import CryptoJS from 'crypto-js'
import AudienceSegmentSelection from "./components/audienceSegmentSelection/audienceSegmentSelection";
import { sumFieldJsonArray } from "./util/dataAgg/sumFieldJsonArray";
import { saveAudience } from "./util/caching/saveAudience";
import { getData, deleteData, saveData } from "./util/caching/indexdbManager";
import { AudienceBreakdown } from "./components/audienceBreakdown/audienceBreakdown";
import { filterShortFallLocations } from "./util/dataAgg/filterShortFallLocations";
import { addToFilterList } from "./util/taggingFavoriteFilter/addFilterToList";
import { removeFilterFromList } from "./util/taggingFavoriteFilter/removeFilterFromList";
import starEmpty from './assets/star-empty.svg'
import starFilled from './assets/star-filled.svg'
import xMark from './assets/xmark.svg'
import { fetchFavoriteFilter, updateFavoriteFilter } from "./util/dataFetches/fetchFavoriteFilters";
import { fetchAudienceSegments } from "./util/dataFetches/fetchAudienceSegments";
import { createSegFilterField } from "./util/dataAgg/createSegFilterField";
import { joinFilterSelections } from "./util/dataAgg/joinFilterSelection";
import { fetchAutomations } from "./util/dataFetches/fetchAutomations";
import LinearProgress from '@material-ui/core/LinearProgress';

const theme = createMuiTheme(mainTheme);
const uuidv4 = require("uuid/v4");

class AudienceBuilder extends React.Component {
  constructor(props) {
    super(props)

    const clientName = JSON.parse(
      CryptoJS.AES.decrypt(
        localStorage.getItem("conceptName"),
        process.env.REACT_APP_PASS
      ).toString(CryptoJS.enc.Utf8)
    )

    const clientId = JSON.parse(
      CryptoJS.AES.decrypt(
        localStorage.getItem("clientId"),
        process.env.REACT_APP_PASS
      ).toString(CryptoJS.enc.Utf8)
    )

    const userId = JSON.parse(
      CryptoJS.AES.decrypt(
        localStorage.getItem("userId"),
        process.env.REACT_APP_PASS
      ).toString(CryptoJS.enc.Utf8)
    )

    this.state = {
      filters: [],
      favoriteFilterIsShowing: false,
      favoriteFilters: [],
      activeFavoriteFilters: new Set(),
      displayedFilters: [],
      displayedFiltersExpanded: new Set(),
      includeList: [],
      excludeList: [],
      includeListLogicString: "",
      excludeListLogicString: "",
      prospectFilterRule: "",
      customerFilterRule: "",
      previewOrEditToggle: true,
      audienceBreakdown: null,
      locationData: [],
      showShortFallNotifications: true,

      // Selection Menu
      channels: [],
      activeChannel: null,
      thresholdSelection: "noThreshold",
      isWholeOrLocation: true,
      targetSpend: null,
      targetQuanity: null,
      audienceRatio: 0.5,
      isGiveMeTheBest: false,
      minProspects: null,
      isFetchingAudiences: false,

      // Audience Info
      defaultAudienceSegments: [],
      audienceSegments: [],
      title: "",
      description: "",
      id: "",

      // Other Config Params
      clientName: clientName,
      clientId: clientId,
      userId: userId,
      lastAbCountsFetch: 0,
      hasInitalizedData: false
    }

    this.controller = new AbortController()
    this.onDrop = this.drop.bind(this)
  }

  async handleFetchSelections() {
    // Fetch Filters
    let [data, campaigns] = await Promise.all([fetchSelections(), fetchAutomations(this.state.clientId)])
    // Configure Custom List Member Filter
    campaigns = {
      label: "Customers",
      type: "multiSelect",
      value: "{CUST_LIST_MEMBER_FILTER}",
      data: campaigns.Items.map(obj => {
        return {
          label: obj.name,
          value: obj.id
        }
      })
    }
    data[0].selectionsjson.push({
      data: [campaigns],
      label: "List Membership",
      type: "select",
      value: "List Membership"
    })

    // Handle Normal Selections
    for (let sectionIdx in data[0].selectionsjson) {
      for (let filterIdx in data[0].selectionsjson[sectionIdx].data) {
        data[0].selectionsjson[sectionIdx].data[filterIdx] = {
          ...data[0].selectionsjson[sectionIdx].data[filterIdx],
          filterType: 'filter',
          id: uuidv4(),
          selectedData: null,
          isAquisition: false,
          isCombined: false
        }
      }
      // Sort Data
      data[0].selectionsjson[sectionIdx].data.sort((a, b) => {
        const labelA = a.label.toLowerCase(); // Convert to lowercase for case-insensitive sorting
        const labelB = b.label.toLowerCase();

        if (labelA < labelB) return -1;
        if (labelA > labelB) return 1;
        return 0; // Equal labels
      })
      data[0].selectionsjson[sectionIdx] = {
        ...data[0].selectionsjson[sectionIdx],
        isAquisition: false,
        isCombined: false
      }
    }

    // Sort Data
    data[0].selectionsjson.sort((a, b) => {
      const labelA = a.label.toLowerCase(); // Convert to lowercase for case-insensitive sorting
      const labelB = b.label.toLowerCase();

      if (labelA < labelB) return -1;
      if (labelA > labelB) return 1;
      return 0; // Equal labels
    });

    // Handle Acqisition - selectionsjsonacquisition
    if (data[0].hasOwnProperty("selectionsjsonacquisition")) {
      // Sort Selections
      for (let sectionIdx in data[0].selectionsjsonacquisition) {
        for (let filterIdx in data[0].selectionsjsonacquisition[sectionIdx].data) {
          data[0].selectionsjsonacquisition[sectionIdx].data[filterIdx] = {
            ...data[0].selectionsjsonacquisition[sectionIdx].data[filterIdx],
            filterType: 'filter',
            id: uuidv4(),
            selectedData: null,
            isAquisition: true,
          }
          data[0].selectionsjsonacquisition[sectionIdx] = {
            ...data[0].selectionsjsonacquisition[sectionIdx],
            isAquisition: true,
          }
        }
        // Sort Data
        data[0].selectionsjsonacquisition[sectionIdx].data.sort((a, b) => {
          const labelA = a.label.toLowerCase(); // Convert to lowercase for case-insensitive sorting
          const labelB = b.label.toLowerCase();

          if (labelA < labelB) return -1;
          if (labelA > labelB) return 1;
          return 0; // Equal labels
        })
      }
      // Sort Data
      data[0].selectionsjsonacquisition.sort((a, b) => {
        const labelA = a.label.toLowerCase(); // Convert to lowercase for case-insensitive sorting
        const labelB = b.label.toLowerCase();

        if (labelA < labelB) return -1;
        if (labelA > labelB) return 1;
        return 0; // Equal labels
      });

      data[0].selectionsjson = joinFilterSelections(data[0].selectionsjson, data[0].selectionsjsonacquisition)
    }

    // Handle Combined - Audience
    if (data[0].hasOwnProperty("selectionsjsoncombined")) {
      // Sort Selections
      for (let sectionIdx in data[0].selectionsjsoncombined) {
        data[0].selectionsjsoncombined[sectionIdx].label += " (Combined)"
        for (let filterIdx in data[0].selectionsjsoncombined[sectionIdx].data) {
          data[0].selectionsjsoncombined[sectionIdx].data[filterIdx] = {
            ...data[0].selectionsjsoncombined[sectionIdx].data[filterIdx],
            filterType: 'filter',
            id: uuidv4(),
            selectedData: null,
            isAquisition: false,
            isCombined: true
          }
          data[0].selectionsjsoncombined[sectionIdx] = {
            ...data[0].selectionsjsoncombined[sectionIdx],
            isAquisition: false,
            isCombined: true
          }
        }
        // Sort Data
        data[0].selectionsjsoncombined[sectionIdx].data.sort((a, b) => {
          const labelA = a.label.toLowerCase(); // Convert to lowercase for case-insensitive sorting
          const labelB = b.label.toLowerCase();

          if (labelA < labelB) return -1;
          if (labelA > labelB) return 1;
          return 0; // Equal labels
        })
      }
      // Sort Data
      data[0].selectionsjsoncombined.sort((a, b) => {
        const labelA = a.label.toLowerCase(); // Convert to lowercase for case-insensitive sorting
        const labelB = b.label.toLowerCase();

        if (labelA < labelB) return -1;
        if (labelA > labelB) return 1;
        return 0; // Equal labels
      });

      data[0].selectionsjson = data[0].selectionsjson.concat(data[0].selectionsjsoncombined)
    }
    // Update Front End
    this.setState({
      displayedFilters: data[0].selectionsjson,
      filters: data[0].selectionsjson
    })

    // Save to Index DB
    await saveData("auienceBuilder", 'abForm', 'abSelections', {
      "selections": data[0].selectionsjson,
      "clientName": this.state.clientName,
      "ttl": Date.now() + 21600000, // 6 Hours
      "channelId": this.state.activeChannel.id
    })
  }

  async handleFetchFavoriteSelections() {
    let favoriteSelections = await fetchFavoriteFilter()

    // Save to Index DB
    await saveData("auienceBuilder", 'abForm', 'favoriteFilters', {
      "selections": favoriteSelections,
      "clientName": this.state.clientName,
      "ttl": Date.now() + 21600000 // 6 Hours
    })

    // Update Front End State
    this.setState(e => {
      e.favoriteFilters = favoriteSelections
      for (let section of favoriteSelections) {
        for (let filter of section.data) {
          e.activeFavoriteFilters.add(filter.label)
        }
      }
      return e
    })
  }

  async handleFetchAudienceSegmentSelections() {
    let audienceSegments = await fetchAudienceSegments()

    // Save to Index DB
    await saveData("auienceBuilder", 'abForm', 'audienceSegments', {
      "selections": audienceSegments,
      "clientName": this.state.clientName,
      "ttl": Date.now() + 43200000 // 12 Hours
    })

    // Update Front End State
    this.setState(e => {
      e.defaultAudienceSegments = audienceSegments
      return e
    })
  }

  componentDidMount() {
    // Async function for fetching audience form data
    const fetchLoadAudience = async () => {
      // Loading a cached audience
      let abData = await getData("auienceBuilder", 'abForm', 'loadAudience')

      // Is Valid Form
      if (abData !== null && abData !== '' && abData !== undefined) {
        // await deleteData("auienceBuilder", 'abForm', 'loadAudience')
        this.setState(e => {
          // Create Logic String for Exclude
          e.excludeListLogicString = buildLogicString(abData.excludeList)
          // Create Logic String for Include
          e.includeListLogicString = buildLogicString(abData.includeList)

          // Return Concat Data
          return { ...e, ...abData }
        })
      }

    }

    // Async function for fetching selections
    const fetchSelections = async () => {
      // Loading cached selections
      let abSelections = await getData("auienceBuilder", 'abForm', 'abSelections')
      if (abSelections !== null && abSelections !== '' && abSelections !== undefined) {
        // Check for the same client
        if (abSelections.clientName === this.state.clientName && abSelections.ttl > Date.now() && this.state.activeChannel.id !== abSelections.channelId) {
          this.setState({
            displayedFilters: abSelections.selections,
            filters: abSelections.selections
          })
        }
        else {
          await deleteData("auienceBuilder", "abForm", "abSelections");

          await this.handleFetchSelections()
        }
      }
      // Fetch AB Selections
      else {
        await this.handleFetchSelections()
      }
    }

    // Async function for fetching favorite selections
    const fetchFavoriteSelections = async () => {
      // Loading Cached Favorite Selections
      let favSelections = await getData("auienceBuilder", 'abForm', 'favoriteFilters')
      // Is favSelections Valid
      if (favSelections) {
        // Check for the same client
        if (favSelections.clientName === this.state.clientName && favSelections.ttl > Date.now()) {
          this.setState(e => {
            e.favoriteFilters = favSelections.selections
            // Add Favorite Filters to activeFavoriteFilters
            for (let section of favSelections.selections) {
              for (let filter of section.data) {
                e.activeFavoriteFilters.add(filter.label)
              }
            }
            return e
          })
        }
        else {
          await deleteData("auienceBuilder", "abForm", "favoriteFilters");
          await this.handleFetchFavoriteSelections()
        }
      }
      else {
        await this.handleFetchFavoriteSelections()
      }
    }

    // Async function for fetching favorite selections
    const fetchAudienceSegments = async () => {
      // Loading Cached Favorite Selections
      let audienceSegments = await getData("auienceBuilder", 'abForm', 'audienceSegments')
      // Is audienceSegments Valid
      if (audienceSegments) {
        // Check for the same client
        if (audienceSegments.clientName === this.state.clientName && audienceSegments.ttl > Date.now()) {
          this.setState(e => {
            e.defaultAudienceSegments = audienceSegments.selections
            return e
          })
        }
        else {
          await deleteData("auienceBuilder", "abForm", "audienceSegments");
          await this.handleFetchAudienceSegmentSelections()
        }
      }
      else {
        await this.handleFetchAudienceSegmentSelections()
      }
    }

    // Fetch all input async
    const asyncManager = async () => {
      await fetchLoadAudience()
      await Promise.any([fetchSelections(), fetchFavoriteSelections(), fetchAudienceSegments()])
      this.setState({ hasInitalizedData: true })
    }
    asyncManager()
  }

  // === DRAG AND DROP ===
  allowDrop(ev) {
    ev.preventDefault();
  }

  drag(ev) {
    try {
      let parsedCustomObj = JSON.parse(ev.target.attributes.customobjdata.value)
      if (parsedCustomObj.hasOwnProperty('createNewId')) {
        const newId = uuidv4()
        parsedCustomObj.id = newId
        delete parsedCustomObj.createNewId
        ev.dataTransfer.setData("text", JSON.stringify({
          "id": newId,
          "customData": JSON.stringify(parsedCustomObj)
        }));
      }
      else {
        ev.dataTransfer.setData("text", JSON.stringify({
          "id": ev.target.id,
          "customData": ev.target.attributes.customobjdata.value
        }));
      }
    }
    catch (e) {
      console.log(e)
    }
  }

  drop(ev) {
    try {
      ev.preventDefault();
      var data = JSON.parse(ev.dataTransfer.getData("text"));
      let selectionItemData = JSON.parse(data.customData)

      // Update Front End
      while (ev.target !== undefined && ev.target !== null && (
        ev.target.id !== 'box-include' &&
        ev.target.id !== 'box-exclude' &&
        ev.target.id !== 'box-filters' &&
        ev.target.id !== 'box-case-block'
      )) {
        ev.target = ev.target.parentNode
      }

      // Handle If Undefined
      if (ev.target === undefined || ev.target === null) {
        return
      }

      // Track where the data is going
      if (ev.target.id === 'box-include') {
        // Remove from Exlude List
        this.setState(e => {
          e.includeList = filterSelectionList(e.includeList, selectionItemData.id);
          e.includeList.push(selectionItemData);
          e.excludeList = filterSelectionList(e.excludeList, selectionItemData.id);
          return e
        })
      }
      else if (ev.target.id === 'box-exclude') {
        // Remove from Include List and update frontend
        this.setState(e => {
          e.excludeList = filterSelectionList(e.excludeList, selectionItemData.id);
          e.excludeList.push(selectionItemData);
          e.includeList = filterSelectionList(e.includeList, selectionItemData.id);
          return e
        })
      }
      // Make sure to remove clone from other lists
      else if (ev.target.id === 'box-filters') {
        // Remove Copyies and update frontend
        this.setState(e => {
          e.excludeList = filterSelectionList(e.excludeList, selectionItemData.id);
          e.includeList = filterSelectionList(e.includeList, selectionItemData.id);
          return e
        })
      }
      // Dropped item in case block
      else if (ev.target.id === 'box-case-block') {
        // Parse New item
        let newNestedCaseBlock = JSON.parse(ev.target.attributes.customobjdata.value)

        // Check to see if selections contain its self
        for (let item of newNestedCaseBlock.filters) {
          if (selectionItemData.id === item.id) {
            return
          }
        }

        // Filter Down Current Selection - Prevent Duplicates
        newNestedCaseBlock.filters = filterSelectionList(newNestedCaseBlock.filters, selectionItemData.id)

        // Add New Item
        newNestedCaseBlock.filters.push(selectionItemData)

        // If dropped item includes itself do not insert
        if (checkOuroboros(newNestedCaseBlock.filters, selectionItemData.id, newNestedCaseBlock.id, [newNestedCaseBlock.id])) {
          return
        }

        // Update Frontend
        this.setState(e => {
          e.excludeList = filterSelectionList(e.excludeList, selectionItemData.id);
          e.excludeList = addSelectionToList(e.excludeList, newNestedCaseBlock);
          e.includeList = filterSelectionList(e.includeList, selectionItemData.id);
          e.includeList = addSelectionToList(e.includeList, newNestedCaseBlock);
          return e
        })
      }

      if (this.state.isFetchingAudiences) {
        // Reset Abort Controller
        this.controller.abort()
        this.controller = new AbortController()
      }

      // Update Logic String
      this.setState(e => {
        // Create Logic String for Exclude
        e.excludeListLogicString = buildLogicString(e.excludeList)
        // Create Logic String for Include
        e.includeListLogicString = buildLogicString(e.includeList)
        // Set Fetch to false
        e.isFetchingAudiences = false
        return e
      })
    }
    catch (e) {
      console.log(e)
    }
  }

  siftFilters(regexString) {
    this.setState(e => {
      let selectedFilters = this.state.favoriteFilterIsShowing ? e.favoriteFilters : e.filters
      // Expand all filters when the search is applied
      if (regexString !== '') {
        for (let item of selectedFilters) {
          e.displayedFiltersExpanded.add(item.label)
        }
      }
      else {
        e.displayedFiltersExpanded = new Set()
      }

      // Filter down filters based on regex
      e.displayedFilters = siftFilterGrouping(selectedFilters, regexString)
      return e
    })
  }
  // ======================

  async handleSave(isSaveAndClose) {
    // Throw and Error if audience has now name
    if (this.state.title === "") {
      alert("Please add a title for your audience. Thank you!")
      return
    }

    // Get Current Data
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    let currentDate = `${year}/${month}/${day}`;

    // Customer, Prospect, or Combined
    let customerType = ""
    if (this.state.isGiveMeTheBest || (this.state.audienceRatio !== 0 && this.state.audienceRatio !== 1)) {
      customerType = "Combined"
    }
    else if (this.state.audienceRatio === 1) {
      customerType = "Customer"
    }
    else {
      customerType = "Prospect"
    }

    // Configure Audience Info
    let newAudience = {
      // Audience Builder General Info
      "id": this.state.id,
      "clientId": this.state.clientId,
      "createdAt": currentDate,
      "customerType": customerType,
      "modifiedAt": currentDate,
      "userId": this.state.userId,
      "title": this.state.title,
      "description": this.state.description,

      // New Audience Builder
      "includeList": this.state.includeList,
      "excludeList": this.state.excludeList,
      "audienceSegments": this.state.audienceSegments,
      "activeChannel": this.state.activeChannel,
      "thresholdSelection": this.state.thresholdSelection,
      "isWholeOrLocation": this.state.isWholeOrLocation,
      "targetSpend": this.state.targetSpend,
      "targetQuanity": this.state.targetQuanity,
      "audienceRatio": this.state.audienceRatio,
      "isGiveMeTheBest": this.state.isGiveMeTheBest,
      "minProspects": this.state.minProspects,
      "audienceBreakdown": this.state.audienceBreakdown,
      "version": "2",

      // LEGACY DEPREICATED BUT STILL NEEDED
      "segmentRule": createSegFilterField(this.state.defaultAudienceSegments, this.state.audienceSegments),
      "prospectFilterRule": this.state.prospectFilterRule,
      "customerFilterRule": this.state.customerFilterRule,
      "aSqlSelectionArr": [],
      "aSqlSelectionArrSegment": [],
      "bSqlSelectionArr": [],
      "bSqlSelectionArrSegment": [],
      "clientConcept": "ca.geo_concept = '1'",
      "counts": this.state.hasOwnProperty('counts') ? [{ ...this.state.counts[0], channelId: this.state.activeChannel.id }] : [],
      "groupLeveltoggle": [],
      "groupLeveltoggleSegment": [],
      "ruleLeveltoggle": [],
      "ruleLeveltoggleSegment": [],
      "segmentName": [],
    }
    await saveAudience(newAudience)
    await saveData("auienceBuilder", 'abForm', 'loadAudience', this.state)

    // Route Save and Close
    if (isSaveAndClose) {
      await deleteData("auienceBuilder", 'abForm', 'loadAudience')
      // Route Back to Audience Page
      window.location.href = '/audiences'
    }
  }

  async handleAudienceFetch() {
    // Fetch Location Data
    if (!this.state.isFetchingAudiences) {
      this.setState(e => e.isFetchingAudiences = true)
      let backendOptions = {
        activeChannel: this.state.activeChannel,
        thresholdSelection: this.state.thresholdSelection,
        isWholeOrLocation: this.state.isWholeOrLocation,
        targetSpend: this.state.targetSpend,
        targetQuanity: this.state.targetQuanity,
        audienceRatio: this.state.audienceRatio,
        isGiveMeTheBest: this.state.isGiveMeTheBest,
        minProspects: this.state.minProspects,
        audienceSegments: this.state.audienceSegments,
        segmentRule: createSegFilterField(this.state.defaultAudienceSegments, this.state.audienceSegments),
        // Filter Selection
        includeList: this.state.includeList,
        excludeList: this.state.excludeList,

        // Client Params
        clientName: this.state.clientName
      }

      // Query API
      let responseData = await fetchCounts(backendOptions, this.controller.signal)
      // Update Front End
      if (responseData !== null) {
        // Marketable
        let sumCustomers = sumFieldJsonArray("Selected Marketable Customers", responseData.location_data)
        let sumProspects = sumFieldJsonArray("Selected Marketable Prospects", responseData.location_data)
        let sumCustomerAccounts = sumFieldJsonArray("Selected Marketable Customer Accounts", responseData.location_data)
        let marketableCustomers = sumCustomers + sumProspects

        // Short Fall Notification
        let shortFallLocations = filterShortFallLocations(responseData.location_data)

        // Control
        let sumCustomersControl = sumFieldJsonArray("Selected Control Customers", responseData.location_data)
        let sumProspectsControl = sumFieldJsonArray("Selected Control Prospects", responseData.location_data)
        let sumControlAccounts = sumFieldJsonArray("Selected Control Customer Accounts", responseData.location_data)
        let sumControl = sumCustomersControl + sumProspectsControl

        this.setState({
          showShortFallNotifications: true,
          locationData: responseData.location_data,
          shortFallLocations: shortFallLocations,
          prospectFilterRule: responseData.prospectFilterRule,
          customerFilterRule: responseData.customerFilterRule,
          audienceBreakdown: {
            marketable: {
              total: marketableCustomers,
              customer_accounts: sumCustomerAccounts,
              prospects: sumProspects,
              customers: sumCustomers
            },
            control: {
              total: sumControl,
              control_accounts: sumControlAccounts,
              prospects: sumProspectsControl,
              customers: sumCustomersControl
            },
            // email: {
            //   total: 0,
            //   test:0
            // }
          },
          // ALSO SAVE COUNTS FOR LEGACY PURPOSES
          counts: [
            {
              "counts": [
                {
                  "customers": {
                    "control": sumControl,
                    "marketable": sumCustomers,
                    "total": sumCustomers
                  },
                  "prospects": {
                    "control": sumProspectsControl,
                    "marketable": sumProspects,
                    "total": sumProspects
                  },
                  "total_customers": {
                    "total": marketableCustomers
                  }
                }
              ],
              "refreshedAt": Date.now()
            }
          ]
        })
      }
      this.setState(e => {
        e.isFetchingAudiences = false
        e.lastAbCountsFetch = Date.now()
        return e
      })
    }
    // Abort Fetch Request
    else {
      this.setState(e => e.isFetchingAudiences = false)
      this.controller.abort()
      this.controller = new AbortController()
    }
  }

  render() {
    try {
      return (
        <React.Fragment>
          <MuiThemeProvider theme={theme}>
            <div className="ab-clean-page">
              {/* Main Screen Content */}
              <div className="ab-mainscreen-content ab-clean-page">
                <div style={{ display: 'inline-block', width: '100%' }}>
                  <div style={{ width: '100%' }}>
                    <SelectionMenu
                      isFetchingAudiences={this.state.isFetchingAudiences}
                      audienceBreakdown={this.state.audienceBreakdown}
                      id={this.state.id}
                      audienceConfig={{
                        "title": this.state.title,
                        "description": this.state.description,
                        "includeList": this.state.includeList,
                        "excludeList": this.state.excludeList,
                        "audienceSegments": this.state.audienceSegments,
                        "activeChannel": this.state.activeChannel,
                        "thresholdSelection": this.state.thresholdSelection,
                        "isWholeOrLocation": this.state.isWholeOrLocation,
                        "targetSpend": this.state.targetSpend,
                        "targetQuanity": this.state.targetQuanity,
                        "audienceRatio": this.state.audienceRatio,
                        "isGiveMeTheBest": this.state.isGiveMeTheBest,
                        "minProspects": this.state.minProspects,
                        "audienceBreakdown": this.state.audienceBreakdown,
                        "segmentRule": createSegFilterField(this.state.defaultAudienceSegments, this.state.audienceSegments),
                      }}
                      previewOrEditToggle={this.state.previewOrEditToggle}
                      onChangePreviewOrEditToggle={(e) => { this.setState({ previewOrEditToggle: e }) }}
                      onChangeChannels={(e) => { this.setState({ channels: e }) }}
                      onChangeActiveChannel={(e) => { this.setState({ activeChannel: e }) }}
                      onAudienceFetch={() => { this.handleAudienceFetch() }}
                      onStartFormLoad={(data) => {
                        // Sync Form Data
                        this.setState(e => {
                          let i = { ...e, ...data }
                          return i
                        })
                      }}
                    />
                  </div>
                  <div style={{ height: '80vh', width: '100%' }}>
                    <div style={{ display: 'flex', flexDirection: !this.state.previewOrEditToggle ? "row-reverse" : "row" }}>
                      <div style={{ display: 'inline-block', width: '20%', height: '80vh', paddingTop: '3vh', paddingBottom: '3vh' }}>
                        {/* Display Edit Audince Section */}
                        <div style={{ backgroundColor: "white", boxShadow: "var(--box-shadow-stripe)", height: '80vh', padding: '5%', borderRadius: 10 }}>
                          {this.state.previewOrEditToggle ? (
                            <div
                              id="box-filters"
                              onDrop={(e) => { this.drop(e) }}
                              onDragOver={(e) => { this.allowDrop(e) }}
                              style={{ position: 'relative' }}
                            >
                              <h2>Search Filters</h2>
                              <Input onChange={(e) => this.siftFilters(e.target.value)} placeholder="Filter Name" style={{ width: '100%' }} />
                              <h2>Filters</h2>
                              <Button style={{ width: "50%" }} onClick={() => {
                                this.setState(e => e.includeList.push({
                                  id: uuidv4(),
                                  label: '[OR Group]',
                                  type: 'case-block',
                                  filterType: 'case-block',
                                  isAnd: false,
                                  isOr: true,
                                  filters: []
                                }))
                              }}>Or Group</Button>
                              <Button style={{ width: "50%" }} onClick={() => {
                                this.setState(e => e.includeList.push({
                                  id: uuidv4(),
                                  label: '[AND Group]',
                                  type: 'case-block',
                                  filterType: 'case-block',
                                  isAnd: true,
                                  isOr: false,
                                  filters: []
                                }))
                              }}>And Group</Button>
                              <div style={{ height: '60vh', width: '100%', padding: '1%', overflow: 'scroll' }}>
                                {!this.state.hasInitalizedData && (
                                  <React.Fragment>
                                    <LinearProgress color="primary" />
                                    <p style={{textAlign:'center'}}>Loading. Please wait!</p>
                                  </React.Fragment>
                                )}
                                {this.state.displayedFilters.map((obj) => {
                                  if (
                                    obj.data.length > 0 
                                    && this.state.activeChannel 
                                    && (
                                      (this.state.activeChannel.combined.hasProspects && obj.isAquisition && !obj.isCombined) 
                                      || (this.state.activeChannel.combined.hasCustomers && !obj.isAquisition && !obj.isCombined)
                                      || (this.state.activeChannel.combined.hasCustomers && this.state.activeChannel.combined.hasProspects && obj.isCombined)
                                    )) {
                                    // if (true) {
                                    return (
                                      <FilterSelector
                                        showFilters={this.state.displayedFiltersExpanded.has(obj.label)}
                                        onDisplayedFiltersExpanded={() => {
                                          this.setState(e => {
                                            // Toggle Filter Grouping
                                            if (e.displayedFiltersExpanded.has(obj.label)) {
                                              e.displayedFiltersExpanded.delete(obj.label)
                                            }
                                            else {
                                              e.displayedFiltersExpanded.add(obj.label);
                                            }
                                            return e
                                          })
                                        }}
                                        onFilterTag={(idx) => {
                                          // Check if filter is already favorited - Remove the Filter
                                          if (this.state.activeFavoriteFilters.has(obj.data[idx].label)) {
                                            this.setState(e => {
                                              const asyncFunc = async () => {
                                                e.activeFavoriteFilters.delete(obj.data[idx].label)
                                                let updatedFilters = await removeFilterFromList(obj.label, e.favoriteFilters, obj.data[idx].label)
                                                e.favoriteFilters = updatedFilters
                                                updateFavoriteFilter(updatedFilters)
                                              }
                                              asyncFunc()
                                              return e
                                            })
                                          }
                                          // Add New Filter
                                          else {
                                            this.setState(e => {
                                              const asyncFunc = async () => {
                                                e.activeFavoriteFilters.add(obj.data[idx].label)
                                                let updateFilters = await addToFilterList(obj.label, e.favoriteFilters, obj.data[idx])
                                                e.favoriteFilters = updateFilters
                                                updateFavoriteFilter(updateFilters)
                                              }
                                              asyncFunc()
                                              return e
                                            })
                                          }
                                        }}
                                        activeFavoriteFilters={this.state.activeFavoriteFilters}
                                        key={obj.label}
                                        label={obj.label}
                                        filters={obj.data}
                                        drag={this.drag}
                                        showAcquisition={this.state.activeChannel && this.state.activeChannel.combined.hasProspects}
                                      />
                                    )
                                  }
                                })}
                              </div>
                              {/* Favorited Filters Button */}
                              <div style={{ position: 'absolute', top: 0, right: 0 }} onClick={() => {
                                this.setState(e => {
                                  e.favoriteFilterIsShowing = !e.favoriteFilterIsShowing;
                                  if (e.favoriteFilterIsShowing) {
                                    e.displayedFilters = e.favoriteFilters
                                  }
                                  else {
                                    e.displayedFilters = e.filters
                                  }
                                  return e
                                })
                              }}>
                                {this.state.favoriteFilterIsShowing ? (
                                  <img src={starFilled} style={{ height: 35, width: 35 }}></img>
                                ) : (
                                  <img src={starEmpty} style={{ height: 35, width: 35 }}></img>
                                )}
                              </div>
                            </div>
                          ) : (
                            // Configure Audience
                            <React.Fragment>
                              <h2>Customize Audience Info</h2>
                              <div style={{ margin: 0, padding: 5, maxHeight: '75vh', overflowY: 'auto' }}>
                                <p><b>Audience Segments</b></p>
                                <AudienceSegmentSelection
                                  selectedData={this.state.audienceSegments}
                                  onSelectedData={(data) => { this.setState(e => { e.audienceSegments = data; return e }) }}
                                  audienceSegments={this.state.defaultAudienceSegments}
                                />
                                <p><b>Audience Name</b></p>
                                <Input
                                  style={{ width: '100%', boxShadow: 'var(--box-shadow-stripe)', borderRadius: 5, padding: 10, marginBottom: '1vh' }}
                                  placeholder="Title"
                                  onChange={(e) => { this.setState({ title: e.target.value }) }}
                                  value={this.state.title}
                                />
                                <p><b>Audience Description</b></p>
                                <Input
                                  style={{ width: '100%', boxShadow: 'var(--box-shadow-stripe)', borderRadius: 5, padding: 10, marginBottom: '1vh' }}
                                  multiline
                                  placeholder="Description"
                                  onChange={(e) => { this.setState({ description: e.target.value }) }}
                                  value={this.state.description}
                                  rows={10}
                                />
                                <Button onClick={() => { this.handleSave(false) }} style={{ margin: '1%', marginTop: '1vh' }} fullWidth color="primary" variant="outlined">Save</Button>
                                <Button onClick={() => { this.handleSave(true) }} style={{ margin: '1%' }} fullWidth color="primary" variant="outlined">Save and Close</Button>
                              </div>
                            </React.Fragment>
                          )}
                        </div>
                      </div>
                      <div style={{ display: 'inline-block', width: '80%', paddingLeft: '1%', paddingRight: 0, paddingTop: '1%', paddingBottom: '1%' }}>
                        {/* Toggle View Based on Sidebar Button */}
                        {this.state.previewOrEditToggle ? (
                          <div style={{ display: 'flex' }}>
                            <div style={{ width: '66.66%', paddingLeft: '1%', paddingRight: 0, paddingTop: '1%', paddingBottom: '1%' }}>
                              <div
                                id="box-include"
                                onDrop={(e) => { this.onDrop(e) }}
                                onDragOver={(e) => { this.allowDrop(e) }}
                                style={{
                                  height: '75vh',
                                  width: '100%',
                                  backgroundColor: '#98FB98',
                                  padding: "1%",
                                  borderRadius: 10,
                                  overflow: "auto"
                                }}
                              >
                                <p><b>Include:</b> {this.state.includeListLogicString}</p>
                                {this.state.includeList.map((obj) => {
                                  return (
                                    <CaseBlock onSelectedData={(filterId, data) => {
                                      // Stop Current Query
                                      if (this.state.isFetchingAudiences) {
                                        this.controller.abort()
                                        this.controller = new AbortController()
                                      }

                                      // Update front end state
                                      this.setState(e => {
                                        e.isFetchingAudiences = false
                                        e.includeList = updateFilterDataById(e.includeList, data, filterId)
                                        e.excludeList = updateFilterDataById(e.excludeList, data, filterId)
                                        return e
                                      })
                                    }}
                                      onFilterDelete={(e) => {
                                        // Stop Current Query
                                        if (this.state.isFetchingAudiences) {
                                          this.controller.abort()
                                          this.controller = new AbortController()
                                        }

                                        this.setState(s => {
                                          s.isFetchingAudiences = false
                                          s.includeList = filterSelectionList(s.includeList, e);
                                          s.includeListLogicString = buildLogicString(s.includeList)
                                          return s
                                        })
                                      }}
                                      key={obj.id} obj={obj} drag={this.drag} onDrop={this.onDrop} onDragOver={this.allowDrop} />
                                  )
                                })}
                              </div>
                            </div>
                            <div style={{ width: '33.33%', paddingLeft: '1%', paddingRight: 0, paddingTop: '1%', paddingBottom: '1%' }}>
                              <div
                                id="box-exclude"
                                onDrop={(e) => { this.onDrop(e) }}
                                onDragOver={(e) => { this.allowDrop(e) }}
                                style={{
                                  height: '75vh',
                                  width: '100%',
                                  backgroundColor: '#f26b4e',
                                  padding: "1%",
                                  borderRadius: 10,
                                  overflow: "auto"
                                }}
                              >
                                <p><b>Exclude:</b> {this.state.excludeListLogicString}</p>
                                {this.state.excludeList.map((obj) => {
                                  return (
                                    <CaseBlock onSelectedData={(filterId, data) => {
                                      // Stop Current Query
                                      if (this.state.isFetchingAudiences) {
                                        this.controller.abort()
                                        this.controller = new AbortController()
                                      }

                                      // Update front end state
                                      this.setState(e => {
                                        e.isFetchingAudiences = false
                                        e.includeList = updateFilterDataById(e.includeList, data, filterId)
                                        e.excludeList = updateFilterDataById(e.excludeList, data, filterId)
                                        return e
                                      })
                                    }}
                                      onFilterDelete={(e) => {
                                        // Stop Current Query
                                        if (this.state.isFetchingAudiences) {
                                          this.controller.abort()
                                          this.controller = new AbortController()
                                        }

                                        this.setState(s => {
                                          s.isFetchingAudiences = false
                                          s.excludeList = filterSelectionList(s.excludeList, e);
                                          s.excludeListLogicString = buildLogicString(s.excludeList)
                                          return s
                                        })
                                      }}
                                      key={obj.id} obj={obj} drag={this.drag} onDrop={this.onDrop} onDragOver={this.allowDrop} />
                                  )
                                })}
                              </div>
                            </div>
                          </div>
                        ) : (
                          // Audience Breakdown Section
                          <React.Fragment>
                            {this.state.activeChannel !== null && (
                              <div style={{ marginTop: '1vh', height: '80vh', boxShadow: 'var(--box-shadow-stripe)', background: 'white', borderRadius: 10, padding: '1%', marginRight: '2vw', overflow: 'auto', position: 'relative' }}>
                                <div style={{ marginTop: '1vh' }}>
                                  <span style={{ boxShadow: 'var(--box-shadow-stripe)', padding: '1%', fontSize: '16px', borderRadius: 5 }}>
                                    {this.state.clientName.charAt(0).toUpperCase() + this.state.clientName.slice(1)} {">"} Channel {">"} <b>{this.state.activeChannel.program}</b>
                                  </span>
                                </div>
                                <AudienceBreakdown audienceBreakdown={this.state.audienceBreakdown} />
                                {/* Short Fall Notification */}
                                {this.state.hasOwnProperty('shortFallLocations')
                                  && !this.state.isWholeOrLocation
                                  && this.state.thresholdSelection !== "noThreshold"
                                  && this.state.showShortFallNotifications
                                  && this.state.shortFallLocations
                                  && this.state.shortFallLocations.length !== 0 && (
                                    <div style={{ position: 'sticky', bottom: 0, left: 0, width: '100%', padding: '1%' }}>
                                      <div style={{ borderRadius: 5, boxShadow: 'var(--box-shadow-stripe)', padding: '1%', backgroundColor: "#ffc067" }}>
                                        <div onClick={() => { this.setState({ showShortFallNotifications: false }) }} style={{ position: 'absolute', top: 10, right: 10 }}>
                                          <img src={xMark} style={{ height: 20, width: 20 }} />
                                        </div>
                                        <h2>Short Fall Notification</h2>
                                        <p>We have identified a shortfall in the following locations:
                                          {this.state.shortFallLocations.map((obj, idx) => {
                                            return (
                                              <span key={obj.locationId}>{obj.locationName}{idx !== (this.state.shortFallLocations.length - 1) ? ", " : ""}</span>
                                            )
                                          })}
                                        </p>
                                      </div>
                                    </div>
                                  )}
                              </div>
                            )}
                          </React.Fragment>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Warning User to Make Screen Bigger */}
              <div className="ab-mainscreen-warning">
                <img src={screenSizeLogo} style={{ maxWidth: '50%' }} />
                <p style={{ textAlign: "center" }}>For the best user experience, please ensure your screen size is maximized.</p>
              </div>
            </div>
          </MuiThemeProvider>
        </React.Fragment>
      );
    }
    catch (e) {
      // Show Alert
      alert(e.toString())
      window.localStorage.clear()
      window.indexedDB.deleteDatabase("auienceBuilder")
      window.location.href = '/login'
    }
  };
}

export default AudienceBuilder;



// WEBPACK FOOTER //
// ./src/views/AudienceBuilder/audienceBuilder.jsx